import React from 'react';
import { Dayjs } from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';
import { DateRange } from '@mui/x-date-pickers-pro';
import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';
import { SingleInputDateRangeField } from '@mui/x-date-pickers-pro/SingleInputDateRangeField';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';

interface ControlledDateRangePickerProps {
  dateRange: DateRange<Dayjs>;
  onDateRangeChange: (newRange: DateRange<Dayjs>) => void;
  label?: string;
  size?: 'small' | 'medium';
  width?: number | string;
}

function ControlledDateRangePicker({
  dateRange,
  onDateRangeChange,
  label,
  size = 'small',
  width = 260,
}: ControlledDateRangePickerProps) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateRangePicker
        value={dateRange}
        onChange={newRange => onDateRangeChange(newRange)}
        slots={{ field: SingleInputDateRangeField }}
        slotProps={{ textField: { size, label, sx: { width } } }}
      />
    </LocalizationProvider>
  );
}

export default ControlledDateRangePicker;
